import React, { useState } from 'react';
import apiClient from '../api';
import 'font-awesome/css/font-awesome.min.css';
import './ProfileEditForm.css';

const POSITIONS = ['Reves', 'Derecha', 'Ambas'];
// const LEVELS = Array.from({ length: 15 }, (_, i) => (i * 0.5).toFixed(1)).filter(l => Number(l) > 0);

const ProfileEditForm = ({ player, onCancel, onSuccess }) => {
    const [formData, setFormData] = useState({
        name: player?.name || '',
        lastName: player?.lastName || '',
        position: player?.position || '',
        // level: player?.level?.toString() || '',
        email: player?.email || '',
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [successMsg, setSuccessMsg] = useState(null);

    const [resetLoading, setResetLoading] = useState(false);
    const [resetMsg, setResetMsg] = useState(null);
    const [resetError, setResetError] = useState(null);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleProfileSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccessMsg(null);

        try {
            const playerId = player.id ?? player.playerId;
            const payload = {
                ...formData
                //level: formData.level ? Number(formData.level) : null
            };

            await apiClient.put(`/players/${playerId}`, payload);
            setSuccessMsg('Datos actualizados correctamente.');
            if (onSuccess) {
                setTimeout(onSuccess, 1500);
            }
        } catch (err) {
            console.error(err);
            setError(err.response?.data?.message || 'Error al actualizar el perfil.');
        } finally {
            setLoading(false);
        }
    };

    const handleSendResetLink = async () => {
        setResetLoading(true);
        setResetMsg(null);
        setResetError(null);

        if (!formData.email) {
            setResetError('No hay un email asociado para enviar el enlace.');
            setResetLoading(false);
            return;
        }

        try {
            await apiClient.post('/password/forgot', { email: formData.email });
            setResetMsg(`Te hemos enviado un enlace a ${formData.email} para cambiar tu contraseña.`);
        } catch (err) {
            setResetError('No se pudo enviar el correo. Inténtalo más tarde.');
        } finally {
            setResetLoading(false);
        }
    };

    return (
        <div className="profile-edit-wrapper">

            {error && (
                <div className="error-banner">
                    <i className="fa fa-exclamation-circle"></i> {error}
                </div>
            )}
            {successMsg && (
                <div className="success-banner">
                    <i className="fa fa-check-circle"></i> {successMsg}
                </div>
            )}

            <form onSubmit={handleProfileSubmit} className="edit-form">

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="name">Nombre</label>
                        <input
                            type="text" id="name" name="name"
                            className="form-control"
                            value={formData.name} onChange={handleChange} required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="lastName">Apellido</label>
                        <input
                            type="text" id="lastName" name="lastName"
                            className="form-control"
                            value={formData.lastName} onChange={handleChange} required
                        />
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                        type="email" id="email" name="email"
                        className="form-control"
                        value={formData.email} onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-row">
                    <div className="form-group select-wrapper">
                        <label htmlFor="position">Posición</label>
                        <select
                            id="position" name="position"
                            className="form-control"
                            value={formData.position} onChange={handleChange}
                        >
                            <option value="">Sin definir</option>
                            {POSITIONS.map(p => <option key={p} value={p}>{p}</option>)}
                        </select>
                    </div>
                    {/* <div className="form-group select-wrapper">
                        <label htmlFor="level">Nivel</label>
                        <select
                            id="level" name="level"
                            className="form-control"
                            value={formData.level} onChange={handleChange}
                        >
                            <option value="">Sin definir</option>
                            {LEVELS.map(l => <option key={l} value={l}>{l}</option>)}
                        </select>
                    </div>*/}
                </div>

                <div className="security-section">
                    <h3 className="section-title"><i className="fa fa-shield"></i> Seguridad</h3>
                    <p className="security-desc">
                        Cambiar contraseña
                    </p>

                    {resetMsg && (
                        <div className="success-banner" style={{marginTop:'10px'}}>
                            <i className="fa fa-envelope"></i> {resetMsg}
                        </div>
                    )}
                    {resetError && (
                        <div className="error-banner" style={{marginTop:'10px'}}>
                            <i className="fa fa-times-circle"></i> {resetError}
                        </div>
                    )}

                    <div style={{marginTop:'16px'}}>
                        <button
                            type="button"
                            className="btn-reset-link"
                            onClick={handleSendResetLink}
                            disabled={resetLoading || resetMsg}
                        >
                            {resetLoading ? (
                                <><div className="spinner-small-dark"></div> Enviando...</>
                            ) : (
                                'Cambiar contraseña'
                            )}
                        </button>
                    </div>
                </div>

                <div className="form-actions">
                    <button type="button" className="btn-cancel" onClick={onCancel} disabled={loading}>
                        Cancelar
                    </button>
                    <button type="submit" className="btn-save" disabled={loading}>
                        {loading ? <div className="spinner-small"></div> : 'Guardar Cambios'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ProfileEditForm;